import { getMapStationIconName } from './getMapStationIconName';
import { getMapStationIconSettings } from './getMapStationIconSettings';

export const getMapStationIcon = (props: any) => getMapStationIconSettings(getMapStationIconName(props), props);
